import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import WithRender from '@/Pages/Admin/Modules/ManageUsers/Profile/About/Views/about-profile.html';
import {common} from '@/Pages/Admin/Modules/Common/Services/Common';
import {trekService} from '@/Pages/Admin/Modules/ManagePackage/Services/Trekservice';
import {ContentModel} from '@/Pages/Admin/Modules/Models/Master/ContentModel';
import {AccountContentModel} from '@/Pages/Admin/Modules/Models/ManageAccount/AccountContentModel';

@WithRender
@Component({})
export default class AboutProfile extends Vue {
    protected ui: any = {};
    protected item: any = {};

    constructor() {
        super();

        this.ui = {
            index: {
                selected: 0,
                edited: -1,
            },
            status: {
                isLoading: {
                    getContent: false,
                    getAboutContent: false,
                },
                postLoading: {
                    saveAboutContent: false,
                },
                editContent: false,
            },
            error: {
                errors: {},
                has_error: false,
                error_message: {},
            },
        };

        this.item = {
            tab: new ContentModel({}),
            selectedTab: new ContentModel({}),
            contentData: new AccountContentModel({}),
            tempContentData: new AccountContentModel({}),
        };
    }

    public created() {
        this.getContent();
    }

    public getContent() {
        this.ui.status.isLoading.getContent = true;
        trekService
            .getAccountContent()
            .then((res: any) => {
                this.item.tab = res.data.data;
                this.item.selectedTab = this.item.tab[0];
                this.getAboutContent();
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.error_message).then(res => {
                    this.ui.error.error_message = res;
                });
            })
            .finally(() => {
                this.ui.status.isLoading.getContent = false;
            });
    }

    public getAboutContent() {
        this.ui.status.isLoading.getAboutContent = false;
        let data = {
            id: this.item.selectedTab.id,
        };
        trekService
            .addAccountContentRetrieve(data)
            .then((res: any) => {
                res.data.data.index = this.ui.index.selected;
                this.item.contentData = res.data.data;
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.error_message).then(res => {
                    this.ui.error.error_message = res;
                });
            })
            .finally(() => {
                this.ui.status.isLoading.getAboutContent = false;
            });
    }

    protected selectedTabContent(content: any, index: any) {
        this.ui.index.selected = index;
        this.item.selectedTab = content;
        this.getAboutContent();
    }

    protected onEditSelectedContentClick() {
        this.ui.status.editContent = true;
        this.ui.index.edited = this.ui.index.selected;
        this.item.tempContentData = Object.assign({}, this.item.contentData);
    }

    protected onCancelSelectedContentClick() {
        this.ui.status.editContent = false;
        this.ui.index.edited = -1;
        this.item.contentData = this.item.tempContentData;
    }

    protected saveSelectedContent() {
        let data = {
            content_id: this.item.selectedTab.id,
            description: this.item.contentData.description,
        };
        this.ui.status.postLoading.saveAboutContent = true;
        trekService
            .addAccountContent(data)
            .then((res: any) => {
                this.ui.status.editContent = false;
                this.item.contentData = res.data.data;
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.error_message).then(res => {
                    this.ui.error.error_message = res;
                });
            })
            .finally(() => {
                this.ui.status.postLoading.saveAboutContent = false;
            });
    }
}
